import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body} from "../styled";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { format } from "date-fns";



const ExperienceData: FC = () => {
  return (
    <Box  sx={{fontSize: '10px', marginBottom: '20px', padding: '10px'}}>
        <Header>
            <Box display='flex' mb={1} mt={2}>
                <TextField
                    label="Дата приема"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "145px", mr: 1 }}
                />
                <TextField
                    label="Дата увольнения"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "147px", mr: 1 }}
                />
                <TextField 
                    label="Лет"
                    variant="outlined"
                    size="small"
                    sx={{ width: "95px"}}
                />
                <TextField 
                    label="Мес."
                    variant="outlined"
                    size="small"
                    sx={{ width: "94px", ml: 1 }}
                />
                <TextField 
                    label="Дн."
                    variant="outlined"
                    size="small"
                    sx={{ width: "94px", ml: 1 }}
                />
                <TextField
                    label="На дату"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", ml: 1 }}
                />
            </Box>
            <Box>
                <TextField 
                    label="К\ф: 1 = 1г3м(0.25) 1 = 1г6м(0.5)"
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1 }}
                />
                <TextField 
                    label="Основание 1-список 1, 2-список 2, 3-выслуга"
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, ml: 1}}
                />
                <TextField 
                    label="Необходимый стаж"
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, ml: 1}}
                />
            </Box>
            <Box>
                <TextField 
                    label="Необходимый возарст Муж."
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1 }}
                />
                <TextField 
                    label="Необходимый возарст Жен."
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, ml: 1}}
                />
            </Box>
        </Header>
        <Body>
            <Box style={{marginTop: '10px'}}>
                <Box>
                    <FormControlLabel
                        label="Стаж общий трудовой"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        label="Стаж непрерывный или выслуга"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        label="Стаж цеховый"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        label="Стаж учатсковый"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        label="Стаж медицинский"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        label="Стаж по специальности"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        label="Стаж для Б/Л"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        label="Стаж льготный"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>
        </Body>

    </Box>
  );
};

export default ExperienceData;
